import React, {Dispatch, SetStateAction} from 'react';
import ToAnLuxPayTransferForm
    from "../../../../../components/ToAnLuxPayTransferForm/ToAnLuxPayTransferForm";


type PropsType = {
    setCurrent: Dispatch<SetStateAction<number>>
    isButtonDisable: boolean | undefined
    setIsButtonDisabled: Dispatch<React.SetStateAction<boolean>>
    tabIndex?: number
}

const ToAnLuxPayStepOne = (props: PropsType) => {

    return (
        <ToAnLuxPayTransferForm
            setCurrent={props.setCurrent}
            isButtonDisable={props.isButtonDisable}
            setIsButtonDisabled={props.setIsButtonDisabled}
            tabIndex={props.tabIndex}
        />

    );
};

export default ToAnLuxPayStepOne;
